import React from 'react';

import { AssetManager } from '../../../../viewer/asset-manager';
import { ElementObj } from '../../../../viewer/elements/element-obj';
import { useSharedView } from '../../../hooks/use-shared-view';
import { useAssetGroupVisibility } from '../hooks/use-asset-group-visibility';

interface CadGroupVisibilityContext {
  toggle: () => void;
  visible: boolean;
  expanded: boolean;
  setExpanded: (expanded: boolean) => void;
}

const CadGroupVisibilityContext = React.createContext<CadGroupVisibilityContext | undefined>(
  undefined,
);

type Props = {
  assets: ElementObj[];
  folderId: string;
  children: React.ReactNode;
};

const CadGroupVisibilityState = (props: Props) => {
  const { visible, toggleVisibility } = useAssetGroupVisibility(
    props.assets,
    AssetManager.instance.isCadGroupVisible(props.folderId) ?? true,
  );
  const { isSharedView } = useSharedView();
  const [expanded, setExpanded] = React.useState(
    isSharedView || (AssetManager.instance.isCadGroupExpanded(props.folderId) ?? false),
  );

  React.useEffect(() => {
    AssetManager.instance.saveCadGroupExpanded(props.folderId, expanded);
  }, [expanded, props.folderId]);

  React.useEffect(() => {
    AssetManager.instance.saveCadGroupVisible(props.folderId, visible);
  }, [visible, props.folderId]);

  return (
    <CadGroupVisibilityContext.Provider
      value={{
        visible,
        toggle: toggleVisibility,
        expanded,
        setExpanded,
      }}
    >
      {props.children}
    </CadGroupVisibilityContext.Provider>
  );
};

export { CadGroupVisibilityContext, CadGroupVisibilityState };
